import { HTMLAttributes } from 'react'
import { classNames, Mods } from '../../lib/classNames/classNames'
import cls from './Card.module.scss'

type Variant = 'default' | 'soft'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
    variant?: Variant
}

export const Card = ({ variant = 'default', className, ...rest }: CardProps) => {
    const mods: Mods = {
        [cls.soft]: variant === 'soft'
    }

    return <div className={classNames(cls.root, mods, [className])} {...rest} />
}

